module.exports = { "default": require("core-js/library/fn/symbol/has-instance"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/has-instance.js
// module id = 277
// module chunks = 0